import { Table } from '@billy/design-system'
import { ReactElement } from 'react'

import { TableIds } from '../../../../../../enums/tableIds'
import { useSalesByCustomerReport } from '../../../../hooks/salesByCustomerReport/useSalesByCustomerReport'
import { useSalesByCustomerReportTableColumns } from '../../../../hooks/salesByCustomerReport/useSalesByCustomerReportTableColumns'
import { useSalesByCustomerReportTableData } from '../../../../hooks/salesByCustomerReport/useSalesByCustomerReportTableData'

export const SalesByCustomerReportTable = (): ReactElement => {
  const { isLoading } = useSalesByCustomerReport()
  const tableData = useSalesByCustomerReportTableData()
  const tableColumns = useSalesByCustomerReportTableColumns()

  return (
    <Table
      columns={tableColumns}
      data={tableData}
      id={TableIds.SalesByCustomerReport}
      isLoading={isLoading}
      withColumnsFiltering={false}
      withStickyHeader
      withPagination={false}
      withSkeletonView
      withFooter
    />
  )
}
